import { useEffect } from 'react';

interface IUseMakeHeaderStickyParams {
  sticky?: boolean;
}

export const useMakeHeaderSticky = (params: IUseMakeHeaderStickyParams | void) => {
  const { sticky = true } = params || {};

  useEffect(() => {
    const headerElement = document.getElementById('header-root');
    if (!headerElement) {
      return;
    }

    if (sticky) {
      headerElement.setAttribute('style', 'position: sticky; top: 0; z-index: 30');
    } else {
      headerElement.removeAttribute('style');
    }
  }, [sticky]);
};

export const useHeaderHeight = () => {
  useEffect(() => {
    const updateHeaderHeight = () => {
      const headerElement = document.getElementById('header-root');
      const height = headerElement?.getBoundingClientRect().height ?? 0;

      document.documentElement.style.setProperty('--header-height', `${height}px`);
    };

    updateHeaderHeight();

    const headerElement = document.getElementById('header-root');

    let resizeObserver: ResizeObserver | null = null;
    if (headerElement) {
      resizeObserver = new ResizeObserver(() => {
        updateHeaderHeight();
      });
      resizeObserver.observe(headerElement);
    }

    window.addEventListener('resize', updateHeaderHeight);

    return () => {
      if (resizeObserver && headerElement) {
        resizeObserver.unobserve(headerElement);
        resizeObserver.disconnect();
      }
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);
};
